import { render, staticRenderFns } from "./UserStudentUpdate.vue?vue&type=template&id=61de03ff&"
import script from "./UserStudentUpdate.vue?vue&type=script&lang=js&"
export * from "./UserStudentUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports